import EmptyPage from '@components/EmptyPage';
import PlugsResolver from '@components/plugs/PlugResolver';
import articlePathsQuery from '@utils/queries/articlePathsQuery';
import articleQuery from '@utils/queries/articleQuery';
import globalQuery from '@utils/queries/globalQuery';
import routeQuery from '@utils/queries/routeQuery';
import { usePreviewSubscription } from '@utils/sanity/sanity';
import { getClient, sanityClient } from '@utils/sanity/sanity.server';
import { GetStaticPaths, GetStaticProps } from 'next';
import React, { FunctionComponent } from 'react';
// index.js

type Props = {
  data;
  preview;
};

const Index: FunctionComponent<Props> = ({ data = {}, preview = null }) => {
  const slug = data?.slug?.current;
  let content;
  const { data: subscribedData } = usePreviewSubscription(routeQuery, {
    params: { slug },
    initialData: data,
    enabled: !!preview,
  });

  if (subscribedData?.content) {
    content = subscribedData.content;
  } else {
    content = data.content;
  }

  return <>{content ? <PlugsResolver plugs={content} /> : <EmptyPage text="Empty page" />}</>;
};

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  const data = await sanityClient.fetch(articlePathsQuery);

  const paths = [];

  locales.forEach((locale, i) => {
    data.forEach((route, j) => {
      try {
        const u = route.slug.current.toString().replace('artikkel/', '');
        paths.push({ params: { id: i * data.length + j, slug: u !== '/' ? u : '' }, locale });
      } catch (error) {
        console.log(error);
      }
    });
  });

  return { paths, fallback: 'blocking' };
};

export const getStaticProps: GetStaticProps = async ({ params, locale, preview = null }) => {
  const { slug } = params;

  const sanitySlug = `artikkel/${slug}`;

  const data = await getClient(preview).fetch(articleQuery, { slug: sanitySlug, locale });
  const global = await getClient(preview).fetch(globalQuery, { locale });

  return { props: { data, global, preview, sanitySlug }, revalidate: 600 };
};

export default Index;
